import { Stack, Typography } from '@mui/material'
import { fontSizes, fontWeights } from '../../../Common/Typography/TypographyStyles'

const TaskAssigneesChart = () => {
  return (
    <Stack
      direction={'column'}
      spacing={2}
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Stack
        direction={'column'}
        spacing={0}
        sx={{
          alignItems: 'center',
        }}
      >
        <Typography sx={{ fontSize: fontSizes.size64, fontWeight: fontWeights[500], p: 0, m: 0 }}>
          200
        </Typography>
        <Typography sx={{ fontSize: fontSizes.size24, fontWeight: fontWeights[500], p: 0, m: 0 }}>
          Assigned Members
        </Typography>
      </Stack>
      <Stack
        direction={'column'}
        spacing={0}
        sx={{
          alignItems: 'center',
        }}
      >
        <Typography sx={{ fontSize: fontSizes.size64, fontWeight: fontWeights[500], p: 0, m: 0 }}>
          140
        </Typography>
        <Typography sx={{ fontSize: fontSizes.size24, fontWeight: fontWeights[500], p: 0, m: 0 }}>
          Completion
        </Typography>
      </Stack>
    </Stack>
  )
}

export default TaskAssigneesChart
